import { useContext, useEffect, useState } from "react"
import { Field, useFormikContext } from "formik"

import { FormContext } from "../../context/formContext"
import { SelectButton } from 'primereact/selectbutton';

import styles from "../../styles/Form.module.css"

import ConsentDialog from "./helpers/ConsentDialog"

export default function TypeConsentDropdown({ field, block, index }) {
  const form = useContext(FormContext)
  const isDisabled = form ? form.blocksSaved[block] : false
  const { values, setFieldValue } = useFormikContext()

  const [dialog, setDialog] = useState(false)
  const [firstMount, setFirstMount] = useState(true)

  useEffect(() => {
    if (values.consent_data_store) {
      if (values.consent_data_store === "No" && !firstMount) {
        setDialog(true)
      }
    }
    setFirstMount(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.consent_data_store])

  const dialogProps = {
    dialog,
    setDialog,
  }
  return (
    <>
      <ConsentDialog {...dialogProps} />
      <div className={styles.field} style={{ order: index }}>
        <div className={styles.button_selector}>
          <div>
            <label className={styles.label}>{field.field_label}</label>
            {field.field_description && (
              <div className={styles.description}>{field.field_description}</div>
            )}
          </div>
          <Field name={field.field_name}>
            {({ field: formikField, meta }) => (
              <>
                <SelectButton
                  id={field.field_name}
                  name={formikField.name}
                  value={formikField.value}
                  onChange={(e) => {
                    const newValue = e.value || values[formikField.name];
                    setFieldValue(formikField.name, newValue);
                  }}
                  disabled={isDisabled}
                  style={{ minWidth: "104px" }}
                  options={field.field_options}
                />
                {meta.touched && meta.error && (
                  <div className={styles.errFieldMsg}>{meta.error}</div>
                )}
              </>
            )}
          </Field>
        </div>
      </div>
    </>
  )
}
